<script>
  import blocksToHtml from '@sanity/block-content-to-html'
  import styles from './interaksjon.module.css'
  import Message from '../assets/message.svelte'
  export let interaksjon
</script>

<style>
  .author {
    margin: 0 0 -16px;
    font-size: 16px;
  }

  .author span {
    font-size: 14px;
    font-weight: 500;
  }

  .message-box {
    position: relative;
    margin: 0 0 -8px;
    width: 100%;
    max-width: 350px;
  }

  .button {
    background: var(--interaction-cta);
    color: var(--nav-active-foreground);
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 26px;
    text-decoration: none;
    font-size: 16px;
    max-width: 255px;
    width: 100%;
  }
</style>

<h3 class="author">{interaksjon.kontaktperson.name}, <span>{interaksjon.rolle}</span></h3>
<div class="message-box">
  <div class="message">
    <Message image={interaksjon.bilde?.crops[0].url} />
    <div class={styles.tekst}>
      {@html `${blocksToHtml({ blocks: interaksjon.tekst })}`}
    </div>
  </div>
</div>
<a class="button" href="mailto:{interaksjon.kontaktperson.email}">{interaksjon.cta}</a>
